import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { InvoiceContentSelectionFormType, QuotationFormProps } from "models/propTypes/invoicePropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { InvoiceFormTypes } from "models/formTypes";
import { WintFormSetValues } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region  components
import { ContentSelectionStep, CustomerSelectionStep } from "components/invoice";
import { useWintForm, useWintWizard, WintForm, WizardFormSectionContainer } from "components/common/wintForms";
import QuotationDraftFooter from "../draftFooter";
import QuotationTemplatePreview from "./fields/quotationTemplatePreview";
import QuotationWizardQuickSelection from "./fields/wizardQuickSelection";
import OtherSettingsStep from "./fields/otherSettingsStep";
import QuotationRutRotSelectionStep from "./fields/rutRotSelectionStep";
//#endregion

const QuotationForm: ForwardRefRenderFunction<FormHandles, QuotationFormProps> = (props, ref) => {
  const { quotation, hasROT, hasRUT } = props;

  const { wintFormProps, formState, connect, values, errors, touched, submitted, setValues } =
    useWintForm<InvoiceFormTypes.Create>({
      formRef: ref,
      defaultValues: props.defaultValues,
      validationSchema: props.validationSchema,
      onFormValidationChange: props.onFormValidationChange,
      validateOnChange: false,
      validateOnMount: true,
      validateOnBlur: true,
    });

  const wizard = useWintWizard(formState);

  return (
    <WintForm {...wintFormProps}>
      <QuotationWizardQuickSelection connect={connect} />
      <QuotationTemplatePreview values={values} quotation={quotation} />
      <WizardFormSectionContainer wizardProps={wizard}>
        <CustomerSelectionStep
          connect={connect}
          values={values}
          submitted={submitted}
          setValues={setValues}
          wizardProps={wizard}
          isQuotation
        />
        <ContentSelectionStep
          connect={connect}
          values={values}
          errors={errors}
          touched={touched}
          submitted={submitted}
          wizardProps={wizard}
          isQuotation
          setValues={setValues as WintFormSetValues<InvoiceContentSelectionFormType>}
        />
        {hasROT || hasRUT ? (
          <QuotationRutRotSelectionStep
            connect={connect}
            values={values}
            errors={errors}
            touched={touched}
            submitted={submitted}
            hasROT={hasROT}
            hasRUT={hasRUT}
            wizardProps={wizard}
          />
        ) : undefined}
        <OtherSettingsStep connect={connect} values={values} submitted={submitted} wizardProps={wizard} />
      </WizardFormSectionContainer>
      <QuotationDraftFooter
        quotation={quotation}
        wizardProps={wizard}
        form={formState}
        isFormLoading={formState.values.loadingCustomer !== null}
      />
    </WintForm>
  );
};

export default forwardRef(QuotationForm);
